import { useEffect, useState, useRef } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _BusinessProcess, _HelpDesk, _Inbox, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";

interface Props {
    setOnSubmit: (fn: () => void) => void;
    onSubmitClose: () => void;
}

export const HelpdeskBPM = ({ setOnSubmit, onSubmitClose }: Props) => {

    const _bProcess = useDataBean(_BusinessProcess);
    const _helpDesk = useDataBean(_HelpDesk);
    const { instance } = useDataBean(_Inbox);

    const [props, setProps] = useState<any>({
        Observation: ""
    });

    const propsRef = useRef<any>({});

    useEffect(() => {
        const initialProps = {
            Observation: "",
            FromDate: _single.getCurrenDate(),
            User: _single.getAccountID(),
            IDEmployee: _single.getAccountID(),
            Solicitante: _single.getAccount().EntityName,
            Since: _single.getCurrenDate()
        };

        setProps(initialProps);
        propsRef.current = initialProps;
    }, []);

    useEffect(() => {
        propsRef.current = props;
    }, [props]);


    useEffect(() => {
        setOnSubmit(() => guardarSolicitud);
    }, []);

    const radicarSolicitado = (IDProcedureImp: number, currentProps: any) => {
        const temp = {
            ...currentProps,
            IDProcedureImp
        };

        _helpDesk.updateCustonBean(temp).then(() => {
            pushResumeInfo(IDProcedureImp, currentProps);
        });
    };

    const pushResumeInfo = (imp: number, currentProps: any) => {
        const resu = {
            Solicitud: currentProps.Observation,
            Nombre: _single.getAccount().EntityName,
            Correo: _single.getAccount().eMail,
            Telefono: _single.getAccount().Tel
        };

        instance
            .pushResumeBpm(
                imp,
                _single.getAccountID(),
                _single.jsonToBootstrapTable(resu)
            )
            .catch(err => console.log("Error en actualizar", err));
    };

    const guardarSolicitud = () => {
        const currentProps = propsRef.current;

        if (!currentProps.Observation?.trim()) {
            toast.warning("Debe ingresar la justificación de la solicitud");
            return;
        }

        _bProcess.instance.requestBusinessProcess(_single.getAccountID(), currentProps.Observation, "SHD", "IDAccount", _single.getAccountID(), JSON.stringify(currentProps), "").then((resp) => {
            if (resp?.AlphaCode) {
                toast.success("Se generó la solicitud No. " + resp.AlphaCode + ". Consulte su bandeja personal para seguimiento.");
                radicarSolicitado(resp.IDProcedureImp, currentProps);
                onSubmitClose();
            }
        })
            .catch(err => {
                toast.error("No se pudo iniciar la solicitud: " + err);
            });
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <label>Justificación de la Solicitud</label>
                <textarea
                    className="form-control"
                    placeholder="¿En qué podemos ayudarte? Describe tu solicitud con el mayor detalle posible."
                    value={props.Observation || ""}
                    onChange={(e) => {
                        e.target.style.height = "auto"; e.target.style.height = `${e.target.scrollHeight}px`;
                        setProps({
                            ...props,
                            Observation: e.target.value
                        });
                    }}
                />
                <span>
                    <strong>Nota:</strong>
                    <p>
                        Esta solicitud será enviada y gestionada por el área de soporte técnico de la entidad.
                    </p>
                </span>
            </div>
        </div>
    );
};
